/**
 * @module types/settings/columnPercentage
 * @description 表格列占比配置（存储字段名 `column_percentage`）
 */

export interface IMetricPercentageItem {
  metric: string;
  table_code: string;
}

/** 空列表的模块级默认引用（数组分支 @stable） */
export const COLUMN_PERCENTAGE_DEFAULT: IMetricPercentageItem[] = Object.freeze(
  [],
) as IMetricPercentageItem[];
